import { IonButton, useIonAlert } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { assignLocations } from "../../../store/userProfileLocation/actions/assignLocations";
import { selectLocationsSelectedCounter } from "../../../store/userProfileLocation/selector/selectLocationsSelectedCounter"

export const ConfirmButton = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const selectedLocationsCounter = useSelector(selectLocationsSelectedCounter);

  const onSubmit = async () => {
    dispatch(assignLocations());
  };

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        onClick={() => {
          present({
            header: `¿Deseas asignar ${selectedLocationsCounter} ${
              selectedLocationsCounter === 1 ? "planta" : "plantas"
            }?`,
            buttons: [
              "No",
              {
                text: `Asignar ${selectedLocationsCounter} ${
                    selectedLocationsCounter === 1 ? "planta" : "plantas"
                }`,
                handler: () => onSubmit(),
              },
            ],
          });
        }}
      >
        Guardar
      </IonButton>
    </>
  );
};